// router
import { useHistory } from 'react-router-dom'
// hooks
import useAudit from './useAudit'

const useRouterControl = () => {
	// router
	const history = useHistory()

	// hooks
	const { events, handledSaveEventRegistry } = useAudit()

	// actions
	const routerControl = ({ link, state = false, idServices }) => {
		if (!link || typeof link !== 'string' || link.length === 0) {
			return
		}

		if (link.includes('https://', 'http://', 'www')) {
			idServices &&
				handledSaveEventRegistry({
					eventName: events[10],
					caller: idServices,
					trackTime: false
				})
			return window.open(link, '_blank')
		}

		const params = state ? { pathname: link, state: state || null } : link

		return history.push(params)
	}

	const goBackControl = () => history.goBack()

	return {
		routerControl,
		goBackControl
	}
}

export default useRouterControl
